module.exports = __webpack_public_path__ + "static/media/up.dfd1f3a9.png";